import {
  Server, Brain, Workflow, BookOpen, Terminal, Container,
  Cloud, Boxes, Settings, GitMerge, ShieldCheck, Cpu, Sparkles,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface UniversityCourseMeta {
  id: string;
  icon: LucideIcon;
  categoryIndex: number;
  levelIndex: number;
  techCount: number;
  prereqCount: number;
  chapterCount: number;
}

export const universityCourseMeta: UniversityCourseMeta[] = [
  { id: 'sovereign-ai-foundations', icon: Brain, categoryIndex: 0, levelIndex: 1, techCount: 4, prereqCount: 2, chapterCount: 4 },
  { id: 'langgraph-agent-development', icon: Sparkles, categoryIndex: 0, levelIndex: 2, techCount: 4, prereqCount: 2, chapterCount: 5 },
  { id: 'hugging-face-in-practice', icon: Cpu, categoryIndex: 0, levelIndex: 1, techCount: 4, prereqCount: 1, chapterCount: 4 },
  { id: 'n8n-workflow-automation', icon: Workflow, categoryIndex: 3, levelIndex: 0, techCount: 4, prereqCount: 1, chapterCount: 5 },
  { id: 'claude-code-production', icon: Terminal, categoryIndex: 0, levelIndex: 1, techCount: 4, prereqCount: 2, chapterCount: 5 },
  { id: 'proxmox-vmware-migration', icon: Container, categoryIndex: 1, levelIndex: 1, techCount: 4, prereqCount: 2, chapterCount: 4 },
  { id: 'ai-infrastructure-operations', icon: Cloud, categoryIndex: 1, levelIndex: 2, techCount: 4, prereqCount: 1, chapterCount: 5 },
  { id: 'open-source-ai-stack', icon: Boxes, categoryIndex: 0, levelIndex: 0, techCount: 4, prereqCount: 1, chapterCount: 4 },
  { id: 'devops-safety-automation', icon: GitMerge, categoryIndex: 3, levelIndex: 1, techCount: 4, prereqCount: 1, chapterCount: 4 },
  { id: 'identity-access-management', icon: ShieldCheck, categoryIndex: 1, levelIndex: 1, techCount: 4, prereqCount: 1, chapterCount: 4 },
  { id: 'zimbra-system-administration', icon: Server, categoryIndex: 2, levelIndex: 1, techCount: 4, prereqCount: 2, chapterCount: 5 },
  { id: 'zimbra-daily-administration', icon: Settings, categoryIndex: 2, levelIndex: 0, techCount: 3, prereqCount: 1, chapterCount: 3 },
  { id: 'atai-security-review', icon: BookOpen, categoryIndex: 3, levelIndex: 2, techCount: 4, prereqCount: 2, chapterCount: 3 },
];

export const getCourseMeta = (id: string): UniversityCourseMeta | undefined =>
  universityCourseMeta.find((course) => course.id === id);
